import React, { memo } from 'react';
import { Navigate, useLocation } from 'react-router';
import { Box, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

// Unauthorized access component
const UnauthorizedAccess = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      gap: 2,
      textAlign: 'center',
      p: 3,
    }}
  >
    <Typography variant="h5" color="error">
      Không có quyền truy cập
    </Typography>
    <Typography variant="body1" color="text.secondary">
      Bạn không có quyền truy cập vào trang này.
    </Typography>
  </Box>
);

// Main RouteGuard component
const RouteGuard = memo(({ 
  children, 
  requiresAuth = false, 
  requiresGuest = false, 
  roles = [], 
  fallback = '/login' 
}) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  // Handle guest-only routes (like login page)
  if (requiresGuest && isAuthenticated) {
    // Redirect to intended page or dashboard
    const from = location.state?.from?.pathname || '/dashboard';
    return <Navigate to={from} replace />;
  }

  // Handle protected routes
  if (requiresAuth && !isAuthenticated) {
    // Save the attempted location for redirecting after login
    return <Navigate to={fallback} state={{ from: location }} replace />;
  }

  // Handle role-based access control
  if (requiresAuth && isAuthenticated && roles.length > 0) {
    const userRole = user?.role;
    const hasRequiredRole = roles.includes(userRole);
    
    if (!hasRequiredRole) {
      return <UnauthorizedAccess />;
    }
  }

  // All checks passed, render the children
  return children;
});

RouteGuard.displayName = 'RouteGuard';

export default RouteGuard; 